import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';

// Declarative Form Rules
// This component uses React Final Form Listeners to listen to the change of one field
// to then update the value of other fields.

// https://medium.com/@erikras/declarative-form-rules-c5949ea97366

const WhenFieldChanges = ({ field, becomes, set, to }) => (
  <Field name={set} subscription={{}}>
    {(
      // No subscription. We only use Field to get to the change function
      { input: { onChange } }
    ) => (
      <OnChange name={field}>
        {value => {
          if (value === becomes) {
            onChange(to);
          }
        }}
      </OnChange>
    )}
  </Field>
);

WhenFieldChanges.defaultProps = {
  to: '',
};

WhenFieldChanges.propTypes = {
  becomes: PropTypes.PropTypes.any.isRequired,
  field: PropTypes.string.isRequired,
  set: PropTypes.string.isRequired,
  to: PropTypes.any,
};

export default WhenFieldChanges;
